export default __webpack_public_path__ + "static/media/road-network-mtr.fa5be34c.svg";